import { render, staticRenderFns } from "./smsRecordForm.vue?vue&type=template&id=08718d9a&scoped=true"
import script from "./smsRecordForm.vue?vue&type=script&lang=js"
export * from "./smsRecordForm.vue?vue&type=script&lang=js"
import style0 from "./smsRecordForm.vue?vue&type=style&index=0&id=08718d9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08718d9a",
  null
  
)

export default component.exports